import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w100 OneMessageContent"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "w100 pad10" }
const _hoisted_4 = { class: "fs10 centered" }
const _hoisted_5 = {
  class: "w80 lgreyBg pad10 fs12 kaigyo",
  style: {"margin-left":"10%","border-radius":"14px","text-align":"center","line-height":"18px"}
}
const _hoisted_6 = {
  key: 1,
  class: "pad5"
}
const _hoisted_7 = {
  class: "fs10 centered",
  style: {"margin-bottom":"10px"}
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_12 = {
  key: 1,
  class: "w100 borderGrey pad5 rad8 mt10 yellowBg"
}
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "fs11 fw600 fl mt3" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = {
  key: 0,
  class: "mt10"
}
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = {
  key: 1,
  class: "fs11 ml20"
}
const _hoisted_19 = {
  key: 2,
  class: "fs11 ml20"
}
const _hoisted_20 = { key: 0 }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_22 = {
  key: 3,
  class: "fs11 ml20"
}
const _hoisted_23 = { key: 0 }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_29 = { key: 0 }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_31 = { key: 2 }
const _hoisted_32 = { class: "w100 borderGrey pad5 rad8 mt10 yellowBg" }
const _hoisted_33 = { class: "fs11 fw600 fl mt3" }
const _hoisted_34 = { key: 0 }
const _hoisted_35 = { class: "fs11 ml20" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("span", { class: "fw600" }, "エラー内容:", -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserIcon = _resolveComponent("UserIcon")!
  const _component_UserFileImage = _resolveComponent("UserFileImage")!

  return (_ctx.hist)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.hist.is_system)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.createdTime), 1),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.hist.message), 1)
                ])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.hist.createdAtText), 1),
              _hoisted_8,
              (_ctx.hist && _ctx.hist.message.length > 0)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(`${_ctx.isMe ? `fr` : ``} w80`)
                  }, [
                    (!_ctx.isMe && _ctx.currentMem)
                      ? (_openBlock(), _createBlock(_component_UserIcon, {
                          key: 0,
                          width: 36,
                          canEdit: false,
                          member: _ctx.currentMem,
                          class: "fl mr10 posRe",
                          showTooltip: true
                        }, null, 8, ["member"]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", {
                      class: _normalizeClass(`${_ctx.isMe ? `fr` : `fl`}`),
                      style: _normalizeStyle({
                        width: _ctx.isMe ? `` : `calc( 100% - 50px )`,
                    })
                    }, [
                      _createElementVNode("span", {
                        class: _normalizeClass(`fw600 fs13 ddgrey ${_ctx.isMe ? `fr` : `fl`}`)
                      }, _toDisplayString(_ctx.hist.message), 3),
                      _hoisted_9,
                      _createElementVNode("span", {
                        class: _normalizeClass(`fs11 dgrey ${_ctx.isMe ? `fr` : `fl`}`)
                      }, _toDisplayString(_ctx.hist.option_messages.join(",")), 3),
                      _hoisted_10,
                      (_ctx.hist.request_id)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            class: _normalizeClass(`fs11 grey ${_ctx.isMe ? `fr` : `fl`}`)
                          }, "リクエストID: " + _toDisplayString(_ctx.hist.request_id), 3))
                        : _createCommentVNode("", true)
                    ], 6)
                  ], 2))
                : _createCommentVNode("", true),
              _hoisted_11,
              (_ctx.hist.can_show_admin && _ctx.Util.isPresent(_ctx.hist.options))
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createElementVNode("img", {
                      src: _ctx.$getAssetImageUrl(`/assets/icons/eye.png`),
                      class: "fl mr5",
                      width: "18",
                      height: "18"
                    }, null, 8, _hoisted_13),
                    _createTextVNode("  "),
                    _createElementVNode("div", _hoisted_14, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.hist.options, (option, optionkey, optionindex) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: `${_ctx.hist.history_id}${optionkey}${optionindex}`
                        }, [
                          (_ctx.RoomHistoryDetail.findKeyName(optionkey) != optionkey)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                _createElementVNode("div", null, [
                                  _createTextVNode(_toDisplayString(_ctx.RoomHistoryDetail.findKeyName(optionkey)) + ": ", 1),
                                  (option && typeof option != `string` && !Array.isArray(option))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.RoomHistoryDetail.showHistoryDic(
                                            option,
                                            String(optionkey),
                                            true
                                        ), (opt, optindex) => {
                                          return (_openBlock(), _createElementBlock("p", {
                                            class: "fs11 ml20",
                                            key: optindex
                                          }, [
                                            _createTextVNode(_toDisplayString(opt[0]) + ": ", 1),
                                            _createElementVNode("span", {
                                              innerHTML: opt[1]
                                            }, null, 8, _hoisted_17)
                                          ]))
                                        }), 128))
                                      ]))
                                    : (typeof option == `boolean`)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(_ctx.RoomHistoryDetail.booleanToName(option)), 1))
                                      : (Array.isArray(option))
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                            (String(optionkey) == `start_times`)
                                              ? (_openBlock(), _createElementBlock("p", _hoisted_20, [
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(option, (op, optindex) => {
                                                    return (_openBlock(), _createElementBlock("span", {
                                                      class: "fs11",
                                                      key: optindex
                                                    }, [
                                                      _createTextVNode(_toDisplayString(op.jp_format), 1),
                                                      _hoisted_21
                                                    ]))
                                                  }), 128))
                                                ]))
                                              : _createCommentVNode("", true)
                                          ]))
                                        : (Array.isArray(option))
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                              (String(optionkey) == `start_times`)
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_23, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(option, (op, optindex) => {
                                                      return (_openBlock(), _createElementBlock("span", {
                                                        class: "fs11",
                                                        key: optindex
                                                      }, [
                                                        _createTextVNode(_toDisplayString(op.jp_format), 1),
                                                        _hoisted_24
                                                      ]))
                                                    }), 128))
                                                  ]))
                                                : _createCommentVNode("", true)
                                            ]))
                                          : _createCommentVNode("", true)
                                ]),
                                _hoisted_25
                              ]))
                            : _createCommentVNode("", true),
                          _hoisted_26
                        ]))
                      }), 128)),
                      _hoisted_27
                    ]),
                    _hoisted_28
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                class: _normalizeClass(`${_ctx.isMe ? `fr` : `fl`} fs11 mt10`)
              }, [
                (_ctx.userFiles && _ctx.userFiles.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userFiles, (file, fileindex) => {
                        return (_openBlock(), _createBlock(_component_UserFileImage, {
                          key: fileindex,
                          file: file,
                          showDeleteButton: file.can_delete,
                          type: `wide`,
                          isMe: _ctx.isMe
                        }, null, 8, ["file", "showDeleteButton", "isMe"]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ], 2)
            ])),
        _hoisted_30,
        (_ctx.showCategoryType(_ctx.hist))
          ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("div", _hoisted_33, [
                  (_ctx.hist.medium_category == `integrations_error`)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                        _createElementVNode("div", null, [
                          _createElementVNode("div", null, [
                            _createElementVNode("p", _hoisted_35, [
                              _hoisted_36,
                              _createTextVNode(" " + _toDisplayString(_ctx.hist.options.error_params), 1)
                            ])
                          ]),
                          _hoisted_37
                        ]),
                        _hoisted_38
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _hoisted_39
              ])
            ]))
          : _createCommentVNode("", true),
        _hoisted_40
      ]))
    : _createCommentVNode("", true)
}